export default __webpack_public_path__ + "images/Steak.1e5d73.jpg";